import { Component } from '@angular/core';

@Component({
    selector: 'eraser-svg',
    templateUrl: '../../../../../../src/assets/svgs/eraser.svg',
    styleUrls: ['../svg.component.scss']
})
export class EraserSVG {

}